<span
  class="core-ui-skeleton"
  [class.core-ui-skeleton--circle]="shape === 'circle'"
  [style.height]="heightValue"
  [style.border-radius]="radiusValue"
></span>
